import FetchStatus                        from "../../../../domain/fundamentals/fetch/FetchStatus";
import { ACTION_TYPE, FetchStatusAction } from "./FetchStatusAction";

export const fetchStatusReducer = (state: FetchStatus = new FetchStatus(), action: FetchStatusAction): FetchStatus => {
  switch (action.type) {
    default:
    case ACTION_TYPE.FINISH_FETCH:
      return new FetchStatus();

    case ACTION_TYPE.START_FETCH:
      return new FetchStatus(true);
  }
};